import { embeds } from "./embeds/descs.js";
import { panoScript } from "./pano-script.js";

export default [
  ...embeds,
  {
    name: "Paris by debord",
    collectible: false,
    position: { lat: 52.390783616743995, lng: 13.79157707790346 },
    create(makers) {
      return makers.simpleImage({
        src: "https://i.pinimg.com/originals/95/ce/9c/95ce9c6f6012fb584f541ec5fa93650d.jpg",
        name: "paris by débord",
        id: "paris",
        correctZ: false,
      });
    },
  },
  {
    name: "SI",
    collectible: false,
    position: { lat: 52.39027945524374, lng: 13.790740228679084 },
    create(makers) {
      return makers.simpleImage({
        src: "https://upload.wikimedia.org/wikipedia/en/f/fd/Situationist_International_1957.png?utm_source=en.wikipedia.org&utm_campaign=parser&utm_content=thumbnail_unscaled",
        name: "situationists",
        id: "situationists",
        correctZ: false,
        caption: "Situationist International",
      });
    },
  },
  {
    name: "DD",
    collectible: false,
    position: { lat: 52.39010268941733, lng: 13.791383940765888 },
    create(makers) {
      return makers.customHTML({
        html: `
        <h1>Détournement</h1>
        <h1>Dérive</h1>
        `,
      });
    },
  },
  {
    name: "Hawksmoor",
    collectible: false,
    position: { lat: 52.38969073522597, lng: 13.792008967611801 },
    create(makers) {
      return makers.simpleImage({
        src: "/assets/img/hawksmoor.jpg",
        name: "hawksmoor",
        id: "hawksmoor",
        caption: "Iain Sinclair's map of Hawksmoor churches in London",
        correctZ: false,
      });
    },
  },
  {
    name: "M25",
    collectible: false,
    position: { lat: 52.390306581134425, lng: 13.792851358904926 },
    create(makers) {
      return makers.simpleImage({
        src: "https://media.autoexpress.co.uk/image/private/s--X-WVjvBW--/f_auto,t_content-image-full-desktop@1/v1663064053/autoexpress/2022/09/M25%20motorway%20map.jpg",
        name: "m25",
        id: "m25",
        caption: "M25 motorway around London",
        correctZ: false,
      });
    },
  },
  {
    name: "Derive",
    collectible: false,
    position: { lat: 52.390047748392334, lng: 13.794021346805804 },
    create(makers) {
      return makers.simpleImage({
        src: "https://upload.wikimedia.org/wikipedia/commons/d/db/Sex-majik-2004.GIF?utm_source=en.wikipedia.org&utm_campaign=imageinfo&utm_content=thumbnail_unscaled",
        name: "derive",
        id: "derive",
        caption: "A 2004 dérive poster",
        correctZ: false,
      });
    },
  },
  {
    name: "DD",
    collectible: false,
    position: { lat: 52.39055238111688, lng: 13.794315638621246 },
    create(makers) {
      return makers.customHTML({
        html: `
        <div style="display: flex; align-items: center; gap: 1rem; background: #fff1; backdrop-filter: blur(30px); border-radius: 10px;">
        <img src="https://pngimg.com/uploads/google_maps_pin/google_maps_pin_PNG26.png" width="300px" />
        <h1>a monumental digital image of a vast portion of our planet</h1>
        </div>
        `,
      });
    },
  },
  {
    name: "panoramas",
    collectible: false,
    position: { lat: 52.39021113741126, lng: 13.794635841899648 },
    create(makers) {
      return makers.simpleImage({
        src: "/assets/img/panorama-example.jpg",
        name: "panoramas",
        id: "panoramas",
        caption: "Example of a full equirectangular street view image",
        correctZ: false,
      });
    },
  },
  {
    name: "street-view-time",
    collectible: false,
    position: { lat: 52.39021165922771, lng: 13.79479708927197 },
    create(makers) {
      return makers.simpleImage({
        src: "/assets/img/street-view-time.png",
        name: "street-view-time",
        id: "street-view-time",
        caption: "A more up to date satellite image of where we're standing.",
        correctZ: false,
      });
    },
  },
  {
    name: "panoscript",
    collectible: false,
    position: { lat: 52.39072154367272, lng: 13.79536227320808 },
    create(makers) {
      return makers.customHTML({
        html: `
        <pre class="code-snippet" style="background: #0009; backdrop-filter: blur(10px); color: white; max-height: 20em; overflow: scroll; min-width: 70ch;">
        <code>${panoScript}</code>
        </pre>
        `,
      });
    },
  },
  {
    name: "santamaria",
    collectible: false,
    position: { lat: 52.39040655079497, lng: 13.796098262811475 },
    create(makers) {
      return makers.embed(
        "https://www.mariosantamaria.net/Emerald-black-latency/",
      );
    },
  },
  {
    name: "surveillance",
    collectible: false,
    position: { lat: 52.39103653430955, lng: 13.796657423752833 },
    create(makers) {
      return makers.customHTML({
        html: `
        <h1 style="font-size: 20rem;">👀 Surveillance</h1>
        `,
      });
    },
  },
  {
    name: "surveillance",
    collectible: false,
    position: { lat: 52.391345371692594, lng: 13.799220203962742 },
    create(makers) {
      return makers.customHTML({
        html: `
        <h1 class="blinkyblink">internet as place</h1>
        `,
      });
    },
  },
  {
    name: "suburbia",
    collectible: false,
    position: { lat: 52.39090544625568, lng: 13.799877282601559 },
    create(makers) {
      return makers.simpleImage({
        src: "https://cdn.britannica.com/99/19499-050-2AA9697B/housing-development-Levittown-NY.jpg",
        name: "suburbia",
        id: "suburbia",
        caption: "Suburbia!",
        correctZ: false,
      });
    },
  },
  {
    name: "redlining",
    collectible: false,
    position: { lat: 52.39003531531875, lng: 13.80021539103206 },
    create(makers) {
      return makers.simpleImage({
        src: "https://i.redd.it/cd24a7yaf1z71.jpg",
        name: "redlining",
        id: "redlining",
        caption:
          "Neighbourhood destroyed due to freeway construction in Detroit",
        correctZ: false,
      });
    },
  },
  {
    name: "404",
    collectible: false,
    position: { lat: 52.389654229828054, lng: 13.801131436321974 },
    create(makers) {
      return makers.simpleImage({
        src: "https://cdn.mos.cms.futurecdn.net/y87LyLUSJtRKUQDo6xzLbE-1200-80.jpg",
        name: "404",
        id: "404",
        correctZ: false,
      });
    },
  },
  {
    name: "fb-login",
    collectible: false,
    position: { lat: 52.38963672985937, lng: 13.800318980253335 },
    create(makers) {
      return makers.simpleImage({
        src: "/assets/img/fb-login.webp",
        name: "fb-login",
        id: "fb-login",
        correctZ: false,
      });
    },
  },
  {
    name: "freesound",
    collectible: false,
    position: { lat: 52.388989226135905, lng: 13.800390667552973 },
    create(makers) {
      return makers.embed("https://freesound.org/embed/geotags_box/iframe/");
    },
  },
  {
    name: "embedding",
    collectible: false,
    position: { lat: 52.389408489621765, lng: 13.800371028746634 },
    create(makers) {
      return makers.customHTML({
        html: `
        <h1 class="blinkyblink" style="translate: 0 -200%; animation-duration: 560ms; color: blue;">
         Embedding
         <a href="https://flaneur.fiala.space/" target="_blank">
          <button>FLÂNEUR explorer</button>
         </a>
        </h1>
        `,
      });
    },
  },
  {
    name: "loitering",
    collectible: false,
    position: { lat: 52.388519737382055, lng: 13.799326466398718 },
    create(makers) {
      return makers.customHTML({
        html: `
        <h1 class="blinkyblink" style="translate: 0 -200%; animation-duration: 350ms; color: pink;">😈 LOITERING 😈</h1>
        `,
      });
    },
  },
  {
    name: "dwell",
    collectible: false,
    position: { lat: 52.38805203335273, lng: 13.799425915376984 },
    create(makers) {
      return makers.simpleImage({
        src: "/assets/img/dwell.png",
        name: "dwell",
        id: "dwell",
        caption: "Dwelling - the fastening of attention",
        correctZ: false,
      });
    },
  },
  {
    name: "loitering",
    collectible: false,
    position: { lat: 52.38741591459301, lng: 13.79931290003937 },
    create(makers) {
      return makers.customHTML({
        html: `
        <button style="cursor: pointer; font-size: 4rem; background: #0f0; font-weight: bold; border-radius: 2rem;" onClick="teleportToChile()">
        🚀 Teleport me to Chile
        </button>
        `,
      });
    },
  },
  {
    name: "Bottles",
    collectible: false,
    position: {
      lat: -20.22333,
      lng: -69.78822,
    },
    gltf: "/assets/items/bottles/",
    async create(makers) {
      const item = await makers.threeObject(this.gltf, {
        name: this.name,
        onGround: true,
        big: true,
        cameraPosition: { x: 0, y: 0.6, z: 2.1 },
        lightPosition: { y: 1 },
        env: "/assets/img/difunta.env.jpg",
        scale: 0.4,
      });

      return item;
    },
  },
  {
    name: "DotR",
    collectible: false,
    position: { lat: -20.22282527910323, lng: -69.78856810051307 },
    create(makers) {
      return makers.embed(
        "https://hurryupweredreaming.com/dreams/dead-on-the-roadside",
      );
    },
  },
  {
    name: "animitas-video",
    collectible: false,
    position: { lat: -20.216001655684824, lng: -69.78846083033172 },
    create(makers) {
      return makers.customHTML({
        html: `
        <video controls style="scale: 2; translate: 0 -50%;" autoplay muted loop src="/assets/video/animitas.mp4"></video>
        `,
      });
    },
  },
  {
    name: "summary",
    collectible: false,
    position: { lat: -20.214167055055125, lng: -69.78903735904895 },
    create(makers) {
      return makers.customHTML({
        html: `
        <div style="translate: 0 -100%; padding: 1em; background: #0f09; backdrop-filter: blur(10px); width: 80ch;">
          <h1>Summary</h1>
          <ul>
            <li>psychogeography = playful misuse of place</li>
            <li>street view = directed graph of images representing place</li>
            <li>the internet = directed graph of documents **constituting** place</li>
            <li>psychogeography gives us a set of tools to artistically investigate and inhabit place</li>
            <li>it can be individual, political, spiritual...</li>
          </ul>
          <h2>Psychogeographer's toolkit for the Internet</h2>
          <ul>
            <li>dérive & détournement</li>
            <li>dwelling & loitering</li>
            <li>assembling & embedding</li>
          </ul>
          <button style="font-size: inherit;" onclick="backToStart()">Back to the beginning!</button>
        </div>
        `,
      });
    },
  },
];
